import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
// import {DynamicNavigationService} from '../../../navigation/dynamic-navigation.service';
// import {AuthenticationService} from '@modules/authentication';
import {CommunicationCenterService} from '@modules/communication-center';
import {DataEntity} from 'octopus-connect';
import {GraphInclusiveService} from './services/graph-inclusive.service';
import {ProgressGraphComponent} from './component/progress-graph/progress-graph.component';
// import {AttendanceGraphComponent} from './component/attendance-graph/attendance-graph.component';
import {SharedFiltersComponent} from './component/shared-filters/shared-filters.component';
import {GraphSelectorComponent} from './component/graph-selector/graph-selector.component';
import {MultiGraphViewComponent} from './component/multi-graph-view/multi-graph-view.component';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from 'shared/shared.module';
import {FuseSharedModule} from 'fuse-core/shared.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {CdkTableModule} from '@angular/cdk/table';
import {IsUserLogged} from '../../../guards/is-user-logged.class';
import {FakeStepperComponent} from './component/fake-stepper/fake-stepper.component';
import {defaultRoute} from '../../../settings';
import {IsAtLeastTrainerGuard} from '../../../guards/is-at-least-trainer-guard.service';
import {GraphInclusiveRoutes} from '@modules/graph-inclusive/core/graph-inclusive.routes';
// import {AuthorizationService} from '@modules/authorization';
// import {SyncRules} from '@modules/graph-inclusive/core/model/rules';
import {GraphInclusiveAuthorizationService} from './services/graph-inclusive-authorization.service';
import {IsLearnerGuard} from '../../../guards/is-learner.guard';
import {OwnProgressGraphComponent} from '@modules/graph-inclusive/core/component/own-progress-graph/own-progress-graph.component';
import {SingleGraphViewComponent} from '@modules/graph-inclusive/core/component/single-graph-view/single-graph-view.component';
// import {FuseNavigationItem} from 'fuse-core/types';
import { GraphModule } from 'fuse-core/components/graph/graph.module';
import { /* MatAutocomplete , */ MatAutocompleteModule /*,  MatAutocompleteTrigger */} from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatMomentDateModule} from "@angular/material-moment-adapter";

const routes: Routes = [
    {
        path: 'graph-inclusive',
        children: [
            {
                path: 'multi',
                component: MultiGraphViewComponent,
                children: [
                    // 86c898aem {path: GraphInclusiveRoutes.Attendance, component: AttendanceGraphComponent},
                    {path: GraphInclusiveRoutes.Progress, component: ProgressGraphComponent},
                    {
                        path: '**',
                        redirectTo: GraphInclusiveRoutes.Attendance,
                        pathMatch: 'full'
                    }
                ],
                canActivate: [IsAtLeastTrainerGuard]
            },
            {
                path: 'single',
                component: SingleGraphViewComponent,
                children: [
                    {path: GraphInclusiveRoutes.OwnProgress, component: OwnProgressGraphComponent},
                ],
                canActivate: [IsLearnerGuard]
            },
            {
                path: '**',
                redirectTo: defaultRoute,
                pathMatch: 'full'
            }
        ],
        canActivate: [IsUserLogged]
    }
];

@NgModule({
    declarations: [
        // 86c898aem AttendanceGraphComponent,
        MultiGraphViewComponent,
        GraphSelectorComponent,
        ProgressGraphComponent,
        SharedFiltersComponent,
        FakeStepperComponent,
        SingleGraphViewComponent,
        OwnProgressGraphComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forRoot(routes, {}),
        SharedModule,
        FuseSharedModule,
        MatProgressSpinnerModule,
        CdkTableModule,
        GraphModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatMomentDateModule,
    ],
    providers: [
        IsUserLogged
    ]
})
export class GraphInclusiveModule {
    private static isMenuSet = false;

    constructor(
        // private dynamicNavigation: DynamicNavigationService,
        // private authService: AuthenticationService,
        // private authorizationService: AuthorizationService,
        private communicationCenter: CommunicationCenterService,
        private graphInclusiveAuthorizationService: GraphInclusiveAuthorizationService,
    ) {
        this.communicationCenter
            .getRoom('authentication')
            .getSubject('userData')
            .subscribe((data: DataEntity) => {
                if (data) {
                    this.postAuthentication();
                } else {
                    this.postLogout();
                }
            });

        this.graphInclusiveAuthorizationService.activeRulesOnStartup();
    }


    static forRoot(): ModuleWithProviders<GraphInclusiveModule> {

        return {
            ngModule: GraphInclusiveModule,
            providers: [
                GraphInclusiveService
            ]
        };
    }

    private postLogout(): void {
        // GraphInclusiveModule.isMenuSet = false;
        // this.dynamicNavigation.clearMenuItem('level0', 'graph-inclusive');
        //
        // Object.keys(GraphInclusiveRoutes)
        //     .map(route => GraphInclusiveRoutes[route].toLowerCase())
        //     .map(route => `graph-inclusive-single-${route}`)
        //     .forEach(menuLink => {
        //         this.dynamicNavigation.clearMenuItem('level0', menuLink);
        //     });
    }

    private postAuthentication(): void {
        try {
            // if (!GraphInclusiveModule.isMenuSet && this.authorizationService.currentUserCan<boolean>(SyncRules.seeGraphsLinksInMenu)) {
            //     this.dynamicNavigation.registerModuleMenu('level0', {
            //         'id': 'graph-inclusive',
            //         'title': 'graph-inclusive',
            //         'translate': 'graph_inclusive.menu_link',
            //         'type': 'item',
            //         'icon': 'analytics',
            //         'url': '/graph-inclusive/multi',
            //     });
            //
            //     Object.keys(GraphInclusiveRoutes)
            //         .map(route => GraphInclusiveRoutes[route].toLowerCase())
            //         .map(route => ({
            //             'id': `graph-inclusive-single-${route}`,
            //             'title': `graph-inclusive-single-${route}`,
            //             'translate': `graph_inclusive.single_${route}_link`,
            //             'type': `item`,
            //             'icon': `analytics`,
            //             'url': `/graph-inclusive/single/${route}`,
            //         }) satisfies FuseNavigationItem).forEach(menuLink => {
            //         this.dynamicNavigation.registerModuleMenu('level0', menuLink);
            //     });
            //
            //     GraphInclusiveModule.isMenuSet = true;
            // }
        } catch (e) {
            console.error(e);
        }
    }
}